import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './FireBase'; // Firebase auth import
import { onAuthStateChanged } from 'firebase/auth';
import VerticalNavbar from './components/VerticalNavbar';
import Dashboard from './pages/Dashboard';
import Schemes from './pages/Schemes';
import LoginPage from './components/LoginPage';
import Logout from './components/Logout';
import 'bootstrap/dist/css/bootstrap.min.css';
// import HorizontalNavbar from './components/HorizontalNavbar';
 import CustomerList from './pages/CustomerList';
import Inventory from './pages/Inventory';
import FeedBack from './pages/FeedBack';
import Report from './pages/Report';
import Settings from './pages/Settings';
import SchemeDetail from './pages/SchemeDetails';
import CustomerDetails from './pages/CustomerDetails';
import Transaction from './pages/Transactions';
import Delivery from './pages/Delivery';
import ProcessScheme from './pages/ProcessScheme';
import Loading from './components/Loading';
import BlockedUsers from './pages/BlockedUsers';
import Billing from './pages/Billing';
import BillingDetails from './pages/BillingDetail';
import Packing from './pages/Packing';
import PackingDetails from './pages/PackingDetails';
import Statistics from './pages/Statistics';
import StatisticesDetailed from './pages/StatisticesDetailed';
import DataEntry from './pages/DataEntry';
import BackButton from './components/BackButton';
import FixTransactionDates from './components/FixTransactionDate';
import FixManualTransactions from './components/FixManualTransactions';
// import CustomerDetails from './components/CustomerDetails';
// import FormData from './pages/ContactFormData';


// import UserSettings from './components/UserSettings';

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // To manage loading state while checking auth

  // Check if user is authenticated
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser({
          uid: currentUser.uid,
          email: currentUser.email,
          accessPages: [], // Placeholder for user access pages (You can fetch from Firestore)
        });
      } else {
        setUser(null);
      }
      setLoading(false); // Stop loading after the check
    });

    // Cleanup listener on component unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    // Render loading screen
    return (
      <div className="loading-screen">
      <Loading/>
      </div>
    );
  }

  // ProtectedRoute Component to streamline protection logic
  const ProtectedRoute = ({ children }) => {
    return user ? children : <Navigate to="/login" />;
  };
  if (process.env.NODE_ENV !== 'development') {
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
  }

  return (
    <Router>
      
      <div className="d-flex flex-column">
        <div className="d-flex">
       
          {user && <VerticalNavbar accessPages={user.accessPages} />}
          <div style={{ marginLeft: '20px', padding: '20px', flex: 1 }}>
          <BackButton/>
            <Routes>
             
              <Route path="/" element={<Navigate to="/login" />} /> {/* Redirect to login */}
              <Route path="/login" element={<LoginPage setUser={setUser} />} />

              {/* Protected Routes */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/schemes" element={<ProtectedRoute><Schemes userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/customers" element={<ProtectedRoute><CustomerList userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/inventory" element={<ProtectedRoute><Inventory userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/feedback" element={<ProtectedRoute><FeedBack userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/report" element={<ProtectedRoute><Report userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/transaction" element={<ProtectedRoute><Transaction userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings userId={user?.uid} /></ProtectedRoute>} />
              <Route path="/scheme/:id"  element={<ProtectedRoute><SchemeDetail userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/customerdetails/:cusmid"  element={<ProtectedRoute><CustomerDetails userId={user?.cusmid} /></ProtectedRoute>}  />
              <Route path="/delivery"  element={<ProtectedRoute><Delivery userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/processscheme/:id"  element={<ProtectedRoute><ProcessScheme userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/blockedusers" element={<ProtectedRoute><BlockedUsers userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/billing" element={<ProtectedRoute><Billing userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/billingdetails/:id" element={<ProtectedRoute><BillingDetails userId={user?.uid}/></ProtectedRoute>}/>
              <Route path="/packing" element={<ProtectedRoute><Packing userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/packingdetails/:id" element={<ProtectedRoute><PackingDetails userId={user?.uid}/></ProtectedRoute>}/>
              <Route path="/statistics" element={<ProtectedRoute><Statistics userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/statisticesdetailed/:id" element={<ProtectedRoute><StatisticesDetailed userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/dataentry" element={<ProtectedRoute><DataEntry userId={user?.uid} /></ProtectedRoute>}  />
              <Route path="/transactionbugfix" element={<ProtectedRoute><FixManualTransactions userId={user?.uid}/></ProtectedRoute>}/>
              

              <Route path="/logout" element={<Logout setUser={setUser} />} />
           
              {/* Add more routes as needed */}
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
    // <UserSettings/>
  );
};

export default App;
